import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import { CgPlayListRemove } from "react-icons/cg";
import { MdPlaylistAdd } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { ImUser, ImUserPlus } from "react-icons/im";

import axios from "axios";
function ServiceSetup() {

    const [services, setServices] = useState([]);
    const [emptyQueueText, setEmptyQueueText] = useState("");
    let history = useHistory();

    const addService = () => {
        history.push("/addService");
    }
    useEffect(() => {
        axios.get(process.env.REACT_APP_BASEURL + process.env.REACT_APP_SERVICE_LIST_URL)
            .then((response) => {
                if (response.data.length === 0) {
                    setEmptyQueueText("Empty");
                }
                else {
                    setServices(response.data);
                }

            })
            .catch(err => {
                console.log(err);
            })
    }, [services])
    return (
        <div className="admin-body">
            <Nav
                headerText="ADMIN"
                nav1="Service Setup"
                nav2="Delete Service"
                nav3="Add User"
                nav4="View Users"
                path1="/setupService"
                path2="/removeService"
                path3="/addUser"
                path4="/users"
                icon1={<MdPlaylistAdd />}
                icon2={<CgPlayListRemove />}
                icon3={<ImUserPlus />}
                icon4={<ImUser />}

            />
            <div className="body">
                <div className="service-setup-container">
                    <div className="header-container">
                        <h2>SERVICE SETUP</h2>
                    </div>
                    <hr />
                    <div className="data-container">
                        <div className="new-service-btn-container">
                            <button
                                type="submit"
                                className="new-service-btn"
                                name="submit"
                                onClick={addService}
                            >
                                <Link to="/addService" className="new-service-link">
                                    + New Service
                                </Link>
                            </button>
                        </div>
                        {services.length !== 0 ?
                            <table className="data-inner-container">
                                <tr>
                                    <th className="table-head">Service Name</th>
                                    <th className="table-head">Estimated Duration</th>
                                </tr>
                                {services.map((service) => {
                                    return <tr>
                                        <td className="table-data" key={service.serviceId}>{service.service_description}</td>
                                        <td className="table-data">{service.duration + "mins"}</td>
                                    </tr>
                                })}
                            </table> : <h1>{emptyQueueText}</h1>}
                    </div>
                </div>
            </div>
        </div>





    )
}
export default ServiceSetup;